<script setup lang="ts">
  import LicenseChip from '@leaflink/stash/LicenseChip.vue';
  import { computed } from 'vue';

  import { LicenseType } from '@/models/company';
  import { getLicenseTypeCode } from '@/utils/getLicenseTypeCode';

  interface LicenseTypeChipProps {
    license: {
      type: LicenseType | string;
    };
    title?: string;
  }

  const props = defineProps<LicenseTypeChipProps>();

  const licenseText = computed(() => getLicenseTypeCode(props.license.type));
</script>

<template>
  <LicenseChip :license="licenseText" :title="props.title" />
</template>
